import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ko } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';

registerLocale('ko', ko);

interface IProps {
  id?: string;
  label?: string;
  name: string;
  value?: string;
  onChange?: (e: any) => void;
  className?: string;
  style?: React.CSSProperties;

  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  maxLength?: number;
  error?: string;

  returnType?: 'YMD' | 'DATE';
  defaultValue?: any;
  showTimeSelect?: boolean;
  isLimitMonth?: boolean;
}

const CustomDatetime = (props: IProps) => {
  const [inputValue, setInputValue] = useState<Date | null>();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const didInitRef = useRef(false);

  // props.value가 비동기로 늦게 도착해도 화면에 정상 반영
  useEffect(() => {
    if (props.value) {
      const t1 = props.value.split('+')[0];
      setInputValue(new Date(t1) as any);
    }
  }, [props.value]);

  // defaultValue는 마운트 시 1회만 처리 (onChange 호출 포함)
  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    if (!props.value && props.defaultValue) {
      const malaysiaMoment = moment(props.defaultValue).tz('Asia/Dubai').millisecond(0);
      const serverTimeVal = malaysiaMoment.format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
      handleOnchange(serverTimeVal);
    }
  }, []);

  const handleOnchange = (date: any) => {
    //console.warn(33333, props.value);
    setInputValue(date);
    const malaysiaMoment = moment(date).tz('Asia/Dubai', true).millisecond(0);
    const serverTimeVal = malaysiaMoment.format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
    const e = {
      target: {
        type: 'datebox',
        value: serverTimeVal,
        name: props.name
      }
    };

    props.onChange?.(e);
  };

  useEffect(() => {
    if (!wrapperRef.current) return;

    let icon;
    let input;
    if ('querySelector' in wrapperRef.current) {
      icon = wrapperRef.current.querySelector<HTMLSpanElement>('.react-datepicker__calendar-icon');
    }
    if ('querySelector' in wrapperRef.current) {
      input = wrapperRef.current.querySelector<HTMLInputElement>(
        '.react-datepicker__input-container input'
      );
    }

    if (icon && input) {
      const clickHandler = () => input.click();
      icon.addEventListener('click', clickHandler);

      return () => {
        icon.removeEventListener('click', clickHandler);
      };
    }
  }, []);

  const now = new Date();
  const oneMonthLater = new Date();
  oneMonthLater.setMonth(now.getMonth() + 1);

  return (
    <>
      <div
        className={`custom-date custom-datetime ${props.className || ''}`}
        style={props.style}
        ref={wrapperRef}
      >
        {props.label && <label htmlFor={props.id}>{props.label}</label>}
        <DatePicker
          id={props.id}
          showTimeSelect={props.showTimeSelect ?? true} // 시간 선택 활성화
          timeFormat="HH:mm" // 시간 포맷
          timeIntervals={10} // 분 단위 (10분 단위 선택, 30으로 하면 30분 단위)
          dateFormat="dd-MMM-yyyy HH:mm" // 화면에 보이는 전체 포맷
          selected={inputValue}
          onChange={handleOnchange}
          locale={'en'}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          showIcon
          disabled={props.disabled}
          readOnly={props.readOnly}
          {...(props.isLimitMonth && {
            minDate: now,
            maxDate: oneMonthLater
          })}
        />
        {props.error && <div className="error-text">{props.error}</div>}
      </div>
    </>
  );
};

export default CustomDatetime;
